export default {
    product: {
        description: {
            more: "plus"
        },
        added: "Ajouté au panier"
    }
}